module.exports = __webpack_public_path__ + "static/media/send.d4e5cbbd.svg";